import { Grid, GridCellProps, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import classnames from 'classnames';
import Styles from './styles.module.scss';
import FormHead from '../../components/headings/FromHead';
import { Icon } from '@iconify/react';
import { useState } from 'react';
import AddUser from '../../modal/adduser';
import PopupMenu from '../../components/popupmenu';
import { Link } from 'react-router-dom';
import ConfirmationModal from '../../modal/confirmation/confirmationModal';
import {checkActive, checkStatus} from '../../utils/EllowUtils'

function Users(props: any) {

  const [addUser, setAddUser] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false)
  const customerId = localStorage.getItem('customerId' || '')
  const userLoginId = localStorage.getItem('loginId')
  const [userId, setUserId] = useState<string>('')
  const [confirmation, setConfirmation] = useState<boolean>(false)
  const [status, setStatus] = useState<string>()



  const addNewUser = (data: any) => {
    setEdit(false)
    setUserId('')
    let body = {
      "customerId":customerId,
      "userLoginId":userLoginId,
      "submittedBy": "PROVIDER",
      "userMetadata":{
          "firstName":data.firstName,
          "lastName":data.lastName,
          "designation":data.designation,
          "email":data.email,
          "phone":data.phone && data.phone.toString(),
      }
    }
    props.addNewUser(body)
    setAddUser(false)
  }

  const editUser = (type: string, userId: any) => {
    if (type === 'edit') {
      setAddUser(false)
      setUserId(userId)
      setEdit(true)
      props.getUser(userId)
    }
    else {
      setConfirmation(true)
      setUserId(userId)
      setStatus(type)
    }
  }
  
  const updateUser = (data: any) => {
    let body = {
      "customerId":customerId,
      "userLoginId": userLoginId,
      "userId":userId,
      "submittedBy": "PROVIDER",
      "userMetadata":{
          "firstName":data.firstName,
          "lastName":data.lastName,
          "designation":data.designation,
          "email":data.email,
          "phone":data.phone && data.phone.toString(),
      }
    }
    props.addNewUser(body)
    setEdit(false)

  }

  const changeUserStatus = () => {
    setConfirmation(false)
   let body =  {
      "action":status,
      "customerId":customerId,
      "userId":userId,
      "userLoginId":userLoginId
    }
    props.editUserStatus(body)
  }


  const editCell = (data: GridCellProps) => {    
    return (
      <td>
        <PopupMenu>
          <div className="popupLinks">
            <Link to="" onClick={() => editUser('edit',data.dataItem.user_id)}>
              <Icon icon="lucide:edit-2" />
              Edit
            </Link>
            <Link to="" onClick={() => editUser('primary', data.dataItem.user_id)}>
              <Icon icon="charm:tick"  />
              Set as Primary
            </Link>
            <Link to="" onClick={() => {editUser(data.dataItem.active_status === 4 ?  'disable' : 'enable', data.dataItem.user_id);}} className={Styles.danger}>
              <Icon icon="tabler:user-off" />
             {checkStatus(data.dataItem.active_status)}
            </Link>
            <Link to="" onClick={() => editUser('delete', data.dataItem.user_id)} className={Styles.danger}>
            <Icon icon="icon-park-outline:delete" />
              Delete
            </Link>
          </div>
        </PopupMenu>
      </td>
    )
  }

  const nameCell = (data: GridCellProps) => {   
    return (
      <td>
        <div className={classnames('dotStatus', checkActive(data.dataItem.active_status))}></div>
        {data.dataItem.user_metadata.firstName} {data.dataItem.user_metadata.lastName} 
        {data.dataItem.primary && <span className={classnames('tagBadge', 'primary')}>Primary</span>}
      </td>
    )
  }

  const emailCell = (data: GridCellProps) => {
    return (
      <td>
        {data.dataItem.user_metadata.email}
      </td>
    )
  }

  const phoneCell = (data: GridCellProps) => {
    return (
      <td>
        {data.dataItem.user_metadata.phone}
      </td>
    )
  }

  const designationCell = (data: GridCellProps) => {
    return (
      <td>
        {data.dataItem.user_metadata.designation}
      </td>
    )
  }
  
  return (
    <div >
      <div className="form-group">
        <figure className={Styles.uploadPicWrap}>
        {props.defImage ? <img alt='' src={props.defImage} /> :
          <span className={Styles.noPicWrap}>{props.companyName && props.companyName[0]}{props.companyName && props.companyName[1]}</span>
      }        </figure>
      </div>
      <div className={Styles.userhead}>
        <FormHead>Users</FormHead>
        <button
          className={Styles.addWorkHistory}
          onClick={() => setAddUser(true)}
        >
          <Icon icon="fluent:add-16-filled" />
          Add new user
        </button>
      </div>
      <div className="tableStyle no-min-height">
        <Grid data={props.usersList}>
        <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
          <Column field="name" title="Name" width="180" cell={nameCell}/>
          <Column field="email" title="Email" cell={emailCell} />
          <Column field="designation" title="Designation" cell={designationCell} />
          <Column field="phone" title="Phone Number" cell={phoneCell} />
          <Column cell={editCell}  width="40px"/>
        </Grid>
      </div>
      {addUser && <AddUser onClose={() => setAddUser(false)} clickHandler={addNewUser} />}
      {edit && <AddUser onClose={() => setEdit(false)} clickHandler={updateUser} defaultValues={props.defaultValues} />}
      {confirmation && <ConfirmationModal onClose={() => setConfirmation(false)} submit={changeUserStatus} />}
    </div>
  )
}
export default Users;
